<mat-sidenav-container class="mainWrapper blue_theme  light-theme" autoFocus dir="ltr">
  <!-- ============================================================== -->
  <!-- Vertical Sidebar -->
  <!-- ============================================================== -->

  <mat-sidenav #leftsidenav [disableClose]="!isOver" [mode]="isOver ? 'over' : 'side'" [opened]="!isOver"
    (openedChange)="onSidenavOpenedChange($event)" (closedStart)="onSidenavClosedStart()" class="sidebarNav">
    <div class="flex-layout">
      <app-sidebar (toggleMobileNav)="sidenav.toggle()" [showToggle]="isOver"></app-sidebar>
      <ng-scrollbar class="position-relative" style="height: 100%">
        <mat-nav-list class="sidebar-list">
          @for(group of groupedNavItems; track group.cap.navCap) {
          <app-nav-item [item]="group.cap" [expanded]="isCapExpanded(group.cap.navCap)"
            (toggle)="toggleCap(group.cap.navCap)">
          </app-nav-item>
          <div class="nav-group-items" [class.collapsed]="!isCapExpanded(group.cap.navCap)">
            @for(item of group.items; track item) {
            <app-nav-item [item]="item" (notify)="sidenav.toggle()">
            </app-nav-item>
            }
          </div>
          }
        </mat-nav-list>
      </ng-scrollbar>
    </div>
  </mat-sidenav>



  <!-- ============================================================== -->
  <!-- Main Content -->
  <!-- ============================================================== -->
  <mat-sidenav-content class="contentWrapper" #content>
    <!-- ============================================================== -->
    <!-- VerticalHeader -->
    <!-- ============================================================== -->

    <app-header [showToggle]="!isOver" (toggleCollapsed)="toggleCollapsed()"
      (toggleMobileNav)="sidenav.toggle()"
      [class.instructor-hide-mobile]="isInstructorRoute"></app-header>


    <main class="pageWrapper" [ngClass]="{ 'maxWidth': !isFullWidth, 'has-bottom-nav': isInstructorRoute }">
      <!-- ============================================================== -->
      <!-- Outlet -->
      <!-- ============================================================== -->
      <router-outlet></router-outlet>
    </main>

    <app-instructor-bottom-nav *ngIf="isInstructorRoute"></app-instructor-bottom-nav>
  </mat-sidenav-content>

</mat-sidenav-container>
